import { useMemo } from "react";

import type { ToasterToast } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";
import { useToastStore } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

import CheckCircle from "@/components/ui/icon/check-circle";
import ErrorCircle from "@/components/ui/icon/error-circle";
import Gift from "@/components/ui/icon/gift";
import {
	Toast,
	ToastClose,
	ToastDescription,
	ToastProvider,
	ToastTitle,
	ToastViewport,
} from "@/components/ui/toast/toast";

export { notifyUserEventInfo } from "./_hooks/use-toast";

export const ToastIcon = ({ variant = "default" }: { variant?: ToasterToast["variant"] }) => {
	return (
		<>
			{variant === "default" && <CheckCircle className="shrink-0 fill-zinc-950" />}
			{variant === "error" && <ErrorCircle className="shrink-0 fill-error-600" />}
			{variant === "gift" && <Gift className="shrink-0 fill-zinc-950" />}
		</>
	);
};

export const Toaster = () => {
	const { toasts } = useToastStore();

	// 重複排除
	const filteredToasts = useMemo(
		() => toasts.filter((toast, index, self) => index === self.findIndex((t) => t.id === toast.id)),
		[toasts],
	);

	return (
		<ToastProvider swipeDirection="up">
			{filteredToasts.map(({ id, title, description, action, variant, ...props }) => {
				return (
					<Toast key={id} variant={variant} {...props}>
						<div className="flex items-center gap-x-4">
							<ToastIcon variant={variant} />
							<div className="grid gap-1">
								{title && <ToastTitle className="break-all">{title}</ToastTitle>}
								{description && <ToastDescription>{description}</ToastDescription>}
							</div>
						</div>
						<div>{action}</div>
						<ToastClose />
					</Toast>
				);
			})}
			<ToastViewport />
		</ToastProvider>
	);
};
